import { Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import Paper from "@mui/material/Paper";

import { useRouter } from "next/router";

import React from "react";

import { Highlight } from "react-instantsearch-hooks-web";

import I18nLink from "@/components/Atoms/I18nLink";
import { HitProps } from "@/features/search/types";

const Hit = ({ hit }: HitProps) => {
    const { locale, path } = hit;

    const { locale: userLocale } = useRouter();

    const userFlag = locale === "en" ? "🇬🇧" : "🇫🇷";

    return (
        <Paper
            key={hit.objectID}
            component="article"
            elevation={0}
            variant="elevation"
            sx={{
                width: "100%",
                color: (theme) => theme.palette.typography.main,
                borderBottom: () => `1px solid ${grey[200]}`,
                mb: 2,
                pb: 1
            }}
        >
            <Grid>
                <Grid item xs={12} md={8}>
                    <Typography
                        variant="h5"
                        sx={{ mb: 1, mt: 1, fontWeight: 600, px: 1 }}
                    >
                        <I18nLink href={path} locale={locale}>
                            <Highlight attribute={["title"]} hit={hit} />
                        </I18nLink>
                    </Typography>

                    <Typography sx={{ mb: 1, px: 1 }}>
                        <Highlight attribute={["content"]} hit={hit} />
                    </Typography>

                    <Typography
                        sx={{
                            mb: 0,
                            textTransform: "uppercase",
                            fontWeight: 600,
                            px: 1
                        }}
                    >
                        <small>
                            <I18nLink href={path} locale={locale}>
                                {path.split("/").splice(1).join(" > ")}
                            </I18nLink>{" "}
                            {locale === userLocale ? "" : userFlag}
                        </small>
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Hit;
